import { createContext, useContext } from 'react';

import type { AgendaEditorController } from './useAgendaEditor';

interface AgendaEditorContextValue {
    editor: AgendaEditorController;
    disabled: boolean;
    /** A read-only agenda read as a record of the meeting: no disabled controls, and empty zones say
     * what was not prepared or noted. */
    isRecord: boolean;
    /** Whether a discussion point offers the employee's response. */
    withResponses: boolean;
}

const AgendaEditorContext = createContext<AgendaEditorContextValue | null>(null);

export const AgendaEditorProvider = AgendaEditorContext.Provider;

/** The editor the rows of `AgendaEditor` change, without handing it down through every level. */
export const useAgendaEditorContext = () => {
    const value = useContext(AgendaEditorContext);
    if (!value) {
        throw new Error('useAgendaEditorContext must be used inside AgendaEditor');
    }
    return value;
};
